export interface Messages {
    common: {
        loading: string;
        unauthorized: string;
        not_found: string;
        unknown_error: string;
        hide_details: string;
        ok: string;
        cancel: string;
        edit: string;
        config: string;
        delete: string;
        freedevice: string;
        new: string;
        applications: string;
        clusters: string;
        reset: string;
        noDate: string;
        actions: string;
        free_deviceapplication: string;
        upload_config: string;
        file: string;
        placeholder: string;
        drop_placeholder: string;
        browse_text: string;
        os: string;
        device_id: string;
        device_name: string;
        registered_date: string;
        last_connection_date: string;
        error_freedevice: string;
        users: string;
        user: string;
        status: string;
        id: string;
        created_at: string;
        updated_at: string;
        refresh: string;
        stop: string;
        size: string;
        config_files: string;
        email: string;
        events: string;
    };

    view: {
        Login: {
            login: string;
            password: string;
            connection: string;
            continue: string;
            step_credentials: string;
            step_contract: string;
            step_application: string;
            step_credentials_help: string;
            step_contract_help: string;
            step_application_help: string;
            lost_password: string;
            lost_login: string;
            access_denied: string;
            choose_contract: string;
            choose_contract_placeholder: string;
            choose_application: string;
            choose_application_placeholder: string;
            choose_application_help: string;
            error_choose_contract: string;
            error_choose_application: string;
            error_wrong: string;
            error_not_linked_to_application: string;
            error_session_expired: string;
        };
        LostPassword: {
            title: string;
            login: string;
            send: string;
            back_to_login: string;
            error_wrong: string;
            success: string;
        };
        LostLogin: {
            title: string;
            email: string;
            send: string;
            back_to_login: string;
            error_wrong: string;
            success: string;
        };
        InitPassword: {
            title: string;
            password: string;
            send: string;
            confirm_password: string;
            back_to_login: string;
            error_invalid_token: string;
            error_wrong_password: string;
            success: string;
        };
        Users: {
            title: string;
            error_unable: string;
            new_item: string;
            item: string;
            error_create: string;
            error_password_too_short: string;
            new_password: string;
            new_password_hint: string;
            link_user: string;
            user_to_link: string;
            search_user_placeholder: string;
            no_user_found: string;
            unlink_user: string;
            unlink_user_confirm: string;
        } & { [K in keyof Required<paths['/users/{id}']['get']['responses']['200']['content']['application/json']>]: string };
        Contracts: {
            title: string;
            error_unable: string;
            new_item: string;
            item: string;
            error_create: string;
        } & { [K in keyof Required<paths['/contracts/{id}']['get']['responses']['200']['content']['application/json']>]: string };
        Clusters: {
            title: string;
            error_unable: string;
            new_item: string;
            item: string;
            error_create: string;
            status: string;
            online: string;
            offline: string;
            unknown: string;
            last_seen: string;
            gateways: string;
            sources_free: string;
            destinations_free: string;
            sessions: string;
            ingress: string;
            egress: string;
            memory: string;
            throughput: string;
            chart_period: string;
            system_load: string;
            gateway_availability: string;
            sources: string;
            destinations: string;
            no_history: string;
            stale_snapshot: string;
            live_logs: string;
            logs_redacted: string;
            no_logs: string;
        } & { [K in keyof Required<paths['/clusters/{id}']['get']['responses']['200']['content']['application/json']>]: string };
        Devices: {
            title: string;
            search: string;
            application: string;
            contract: string;
            user: string;
            all_contracts: string;
            all_applications: string;
            no_devices: string;
        };
        Sessions: {
            title: string;
            error_unable: string;
            new_item: string;
            item: string;
            error_create: string;
            search: string;
            source_application: string;
            unknown_source: string;
            unknown_device: string;
            unknown_application: string;
            graph_title: string;
            show_ended_consumers: string;
            all_contracts: string;
            all_clusters: string;
            all_source_applications: string;
            all_consumers: string;
            with_consumers: string;
            without_consumers: string;
            finished_at: string;
            started_at: string;
            ended: string;
            port: string;
            end_released: string;
            end_gone: string;
            end_session_finished: string;
            hls_video: string;
            hls_audio: string;
            hls_metadata: string;
        } & { [K in keyof Required<paths['/sessions/{id}']['get']['responses']['200']['content']['application/json']>]: string };
        Applications: {
            search_device: string;
            no_device_found: string;
            title: string;
            error_unable: string;
            new_item: string;
            item: string;
            error_create: string;
            edit_rights: string;
            error_rights_unable: string;
            error_update_rights: string;
            conflict: string;
            date_order_error: string;
        } & {
            [K in keyof Required<
                paths['/applications/{id}']['get']['responses']['200']['content']['application/json'] &
                    paths['/applications']['post']['requestBody']['content']['multipart/form-data']['data'] &
                    paths['/applications/list']['post']['responses']['200']['content']['application/json'][0]
            >]: string;
        };
        ApplicationTypes: {
            title: string;
            error_unable: string;
            new_item: string;
            item: string;
            error_create: string;
            error_update: string;
            error_delete: string;
            edit_right_templates: string;
            error_right_templates_unable: string;
            new_template: string;
            template_name: string;
            template_description: string;
            is_default: string;
            error_create_template: string;
            error_update_template: string;
            error_delete_template: string;
            right_key: string;
            default_value: string;
            downloads: string;
            downloads_title: string;
            downloads_hint: string;
            downloads_visible_short: string;
            platform: string;
            file: string;
            size: string;
            updated_at: string;
            no_binary: string;
            choose_file: string;
            upload: string;
            delete_binary: string;
            confirm_delete_binary: string;
            error_upload: string;
            error_upload_too_large: string;
            error_downloads_disabled: string;
            error_delete_binary: string;
        } & {
            [K in keyof Required<paths['/applications/types']['get']['responses']['200']['content']['application/json'][0]>]: string;
        };
        Mosaics: {
            title: string;
            new_mosaic: string;
            item: string;
            created: string;
        } & {
            [K in keyof Required<paths['/mosaics']['post']['requestBody']['content']['application/json']>]: string;
        } & {
            [K in keyof Required<GetSessionsMosaicsResponseOkDto['mosaics'][0]>]: string;
        };
        HLS: {
            title: string;
            new_hls: string;
            item: string;
            created: string;
            playback: string;
            expert_mode: string;
            expert_width: string;
            expert_height: string;
            expert_fps: string;
            expert_bitrate_kbps: string;
            expert_positive_fields_error: string;
        } & {
            [K in keyof Required<paths['/HLS']['post']['requestBody']['content']['application/json']>]: string;
        } & {
            [K in keyof Required<paths['/HLS']['get']['responses']['200']['content']['application/json']['items'][0]>]: string;
        };
        SwitchSources: {
            title: string;
            error_unable: string;
            new_item: string;
            item: string;
            error_create: string;
            nomade_gateway_config_dir: string;
        } & { [K in keyof Required<paths['/switches/sources/{id}']['get']['responses']['200']['content']['application/json']>]: string };
        SwitchDestinations: {
            title: string;
            error_unable: string;
            new_item: string;
            item: string;
            error_create: string;
        } & { [K in keyof Required<paths['/switches/destinations/{id}']['get']['responses']['200']['content']['application/json']>]: string };
        Register: {
            title: string;
            error_unable: string;
            confirm_password: string;
            success: string;
            login_already_taken: string;
        } & { [K in keyof Required<paths['/users/register']['post']['requestBody']['content']['application/json']>]: string };
        VOD: {
            title: string;
            new_vod: string;
            item: string;
            created: string;
            playback: string;
            delete: string;
            close: string;
            rename: string;
            put_event: string;
            no_event: string;
            loading_events: string;
            contract: string;
            all_contracts: string;
            all_statuses: string;
            origin_device: string;
            origin_application: string;
            origin_user: string;
            filter_device: string;
            clear_filter: string;
            parts: string;
            show_parts: string;
            part_start: string;
            gap: string;
            merge: string;
            merge_title: string;
            merge_help: string;
            merge_master: string;
            merge_total: string;
            merge_no_candidates: string;
            merge_save: string;
            merge_separate_all: string;
            merge_reason_UNKNOWN_DEVICE: string;
            merge_reason_NOT_UPLOADED: string;
            merge_reason_NO_CLUSTER: string;
            merge_reason_MERGED_INTO_OTHER: string;
        } & {
            [K in keyof Required<paths['/VOD']['post']['requestBody']['content']['application/json']>]: string;
        } & {
            [K in keyof Required<paths['/VOD']['get']['responses']['200']['content']['application/json']['items'][0]>]: string;
        };
        Cars: {
            title: string; number: string; description: string; image: string;
            new_car: string; remove_image: string; delete_help: string;
            invalid_image: string; duplicate_number: string;
        };
        Events: {
            title: string;
            new_event: string;
            item: string;
            created: string;
            download_geojson: string;
            event_map: string;
            debrief_enabled_help: string;
        } & {
            [K in keyof Required<paths['/events']['post']['requestBody']['content']['multipart/form-data']['metadata']>]: string;
        } & {
            [K in keyof Required<paths['/events']['get']['responses']['200']['content']['application/json']['items'][0]>]: string;
        };
    };

    components: {
        Menu: {
            title: string;
            contracts: string;
            users: string;
            connect: string;
            clusters: string;
            application_types: string;
            devices: string;
            sessions: string;
            mosaics: string;
            hls: string;
            vod: string;
        };
        MultiSelect: {
            tagPlaceholder: string;
            placeholder: string;
            selectLabel: string;
            deselectLabel: string;
            selectedLabel: string;
        };
        UserInfos: {
            disconnect: string;
        };
        LanguageSelector: {
            lang: string;
        };
    };

    options: {
        ApplicationOss: Record<ApplicationOs, string>;
        ApplicationSwicthRoles: Record<ApplicationSwicthRole, string>;
        UserTypes: Record<UserType, string>;
        SwitchSourceTypes: Record<SwitchSourceType, string>;
    };
}

import fr from './fr/messages';
import en from './en/messages';
import { paths } from '@/types/types';
import { ApplicationOs } from '@/options/application_os';
import { ApplicationSwicthRole } from '@/options/application_switch_roles';
import { UserType } from '@/options/user_types';
import { GetSessionsMosaicsResponseOkDto } from '../../api/api-client';
import { SwitchSourceType } from '@/options/switch_source_type';

const messages: { [key: string]: any } = { fr: fr, en: en };

export default messages;
